module.exports = __webpack_public_path__ + "static/media/kigali-ampersand.885bb060.jpg";